import * as couponAdd from '../services/couponAdd';

export default {
  namespace: 'couponAdd',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    *getQueryConsumeList({ payload: { values } }, { call, put }) {
      const response = yield call(couponAdd.getQueryConsumeList, values);
      yield put({
        type: 'save',
        payload: {
          couponList: response?.data,
        },
      });
    },

    //获取活动相关信息
    *getActivityInfo({ payload: { values }, callback }, { call, put }) {
      const response = yield call(couponAdd.getActivityInfo, values);
      yield put({
        type: 'save',
        payload: {
          activityInfo: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 清除数据
    *clearActivityInfo({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          activityInfo: [],
          userGroupInfo: null,
        },
      });
    },

    //新增活动人群
    *addActivityStaff({ payload: { values }, callback }, { call }) {
      const response = yield call(couponAdd.addActivityStaff, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     ActivityInfo: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //更新活动人群
    *updateActivityStaff({ payload: { values }, callback }, { call }) {
      const response = yield call(couponAdd.updateActivityStaff, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     ActivityInfo: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/marketing/crowd/registered_unpaid' ||
          props.pathname === '/marketing/crowd/key_recall' ||
          props.pathname === '/marketing/crowd/custom_crowd' ||
          props.pathname === '/marketing/crowd/assign_telephone'
        ) {
          dispatch({
            type: 'clearActivityInfo',
            payload: {
              values: {},
            },
          });
        }
      });
    },
  },
};
